// ChatSocial.js — Réactions + « écrit… » + « vu » pour les chats (via messages de CONTRÔLE Nakama).
// Réutilisable par le chat communauté / privé / groupe. Les réactions sont en-session (diffusées en
// direct à tous les présents ; se réinitialisent au rechargement — suffisant et gratuit).
import React, { useCallback, useRef, useState } from 'react';
import styled from 'styled-components';
import { theme } from '../theme';

export const REACT_EMOJIS = ['❤️', '😂', '👍', '😮', '😢', '🔥'];

// Hook d'état : réactions par message, nom de qui « écrit… », horodatage du dernier « vu ».
export function useChatSocial() {
  const [reactions, setReactions] = useState({}); // msgId -> { emoji: count }
  const [typingName, setTypingName] = useState(null);
  const [seenAt, setSeenAt] = useState(0);
  const timer = useRef(null);

  const bump = (msgId, emoji) => setReactions((r) => { const m = { ...(r[msgId] || {}) }; m[emoji] = (m[emoji] || 0) + 1; return { ...r, [msgId]: m }; });

  // Traite un message de contrôle entrant (react/typing/seen). Renvoie true si c'en était un.
  const handleControl = useCallback((c, senderName, mine) => {
    if (c.react && c.ref) { bump(c.ref, c.react); return true; }
    if (c.typing) {
      if (!mine) { setTypingName(senderName || 'Quelqu\'un'); clearTimeout(timer.current); timer.current = setTimeout(() => setTypingName(null), 4500); }
      return true;
    }
    if (c.seen) { if (!mine) setSeenAt(Date.now()); return true; }
    return false;
  }, []);

  return { reactions, typingName, seenAt, bump, handleControl };
}

// Petit bouton « réagir » + barre d'emojis (clic = réaction). Compatible tactile.
const ReactWrap = styled.span`position: relative; display: inline-flex; vertical-align: middle;
  .trg { background: none; border: none; cursor: pointer; color: ${theme.colors.textMuted}; font-size: .8rem; opacity: .6; padding: 0 .2rem; }
  .trg:hover { opacity: 1; }
  .bar { position: absolute; bottom: 100%; left: 0; display: flex; gap: .1rem; background: ${theme.colors.bgCard};
    border: 1px solid ${theme.colors.borderHover}; border-radius: 999px; padding: .15rem .3rem; box-shadow: ${theme.shadows.card}; z-index: 5; }
  .bar button { background: none; border: none; cursor: pointer; font-size: 1rem; padding: 0 .15rem; line-height: 1.4; }
  .bar button:hover { transform: scale(1.25); }`;

export function ReactBtn({ onReact }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  return (
    <ReactWrap ref={ref} onMouseLeave={() => setOpen(false)}>
      <button className="trg" title="Réagir" onClick={() => setOpen((o) => !o)}>＋</button>
      {open && (
        <span className="bar">
          {REACT_EMOJIS.map((e) => <button key={e} onClick={() => { onReact(e); setOpen(false); }}>{e}</button>)}
        </span>
      )}
    </ReactWrap>
  );
}

// Affichage des réactions d'un message (chips).
export function Reactions({ data }) {
  if (!data) return null;
  const entries = Object.entries(data).filter(([, n]) => n > 0);
  if (!entries.length) return null;
  return (
    <span style={{ display: 'inline-flex', gap: '.25rem', marginLeft: '.35rem', verticalAlign: 'middle' }}>
      {entries.map(([e, n]) => (
        <span key={e} style={{ fontSize: '.72rem', background: theme.colors.bgPrimary, border: `1px solid ${theme.colors.border}`, borderRadius: 999, padding: '0 .35rem' }}>{e} {n > 1 ? n : ''}</span>
      ))}
    </span>
  );
}
